import CallAPI from "@/functions/Cl_api";
import { Cl_common } from "@/functions/Cl_common";
import { DtoClaimsGetReqImple } from "furukawa-common/src/common/dto/DtoClaimsGetReqImple";
import { DtoClaimsGetResImple } from "furukawa-common/src/common/dto/DtoClaimsGetResImple";
import { DtoClaimsPostReq } from "furukawa-common/src/common/dto/abst/DtoClaimsPostReq";
import { DtoClaimsPostRes } from "furukawa-common/src/common/dto/abst/DtoClaimsPostRes";
import { DtoClaimsPutReq } from "furukawa-common/src/common/dto/abst/DtoClaimsPutReq";
import { DtoClaimsPutRes } from "furukawa-common/src/common/dto/abst/DtoClaimsPutRes";
import { DtoClaimsDeleteReq } from "furukawa-common/src/common/dto/abst/DtoClaimsDeleteReq";
import { DtoClaimsDeleteRes } from "furukawa-common/src/common/dto/abst/DtoClaimsDeleteRes";
import { DtoClaimsPostReqImple } from "furukawa-common/src/common/dto/DtoClaimsPostReqImple";
import { DtoClaimsPostResImple } from "furukawa-common/src/common/dto/DtoClaimsPostResImple";

export class Cl_claim {
  public static async getList(
    dto: DtoClaimsGetReqImple
  ): Promise<DtoClaimsGetResImple> {
    return Object.assign(
      new DtoClaimsGetResImple(),
      await CallAPI.getRequest(
        "/claims?" +
          Cl_common.cnvObj2GetParam(dto.pager) +
          "&" +
          Cl_common.cnvObj2GetParam(dto)
      )
    );
  }

  public static async get(
    dto: DtoClaimsGetReqImple
  ): Promise<DtoClaimsGetResImple> {
    return Object.assign(
      new DtoClaimsGetResImple(),
      await CallAPI.getRequest(
        "/claims/" + dto.c_claim_id + "?" + Cl_common.cnvObj2GetParam(dto)
      )
    );
  }

  public static async post(
    dto: DtoClaimsPostReqImple
  ): Promise<DtoClaimsPostResImple> {
    return Object.assign(
      new DtoClaimsPostResImple(),
      await CallAPI.postRequest("/claims", dto)
    );
  }

  public static async put(dto: DtoClaimsPutReq): Promise<DtoClaimsPutRes> {
    return Object.assign(
      new DtoClaimsPutRes(),
      await CallAPI.putRequest("/claims/" + dto.c_claim_id, dto)
    );
  }

  public static async del(
    dto: DtoClaimsDeleteReq
  ): Promise<DtoClaimsDeleteRes> {
    return Object.assign(
      new DtoClaimsDeleteRes(),
      await CallAPI.deleteRequest("/claims?" + Cl_common.cnvObj2GetParam(dto))
    );
  }
}
